<template>
  <div class="card mb-3">
    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
      <h6 class="m-0 font-weight-bold text-primary">{{ is_allow_edit ? 'Upload' : '' }} Photo</h6>
    </div>
    <div class="card-body">
      <img :src="data.picture != '' ? data.picture : image_from_server(data.file_name)" width="100%"/>
      <input type="file" name="photo" accept="image/*" class="d-none" id="file_input" @change="display_image">
      <button name="uploadPhoto" id="uploadPhoto" class="btn btn-outline-primary mt-4 btn-sm" role="button" v-show="is_allow_edit" onclick="$('#file_input').trigger('click')">Upload Photo</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data','is_allow_edit',],
  methods: {
    image_from_server(file_name){
      return base_url+'/images/agent?file_name='+file_name
    },
    display_image(e){

      this.$emit('on-add-picture',event.target.files[0])
    },
  }
}
</script>
